import { createContext, useContext } from "react";

/**
 * Messages Auto Draft — lets an auto-draft bubble deep in the timeline hand its
 * text to the member composer ("Edit") without prop-drilling through every
 * bubble layer. MemberTimeline provides it; outside a timeline it is null and
 * the Edit action is hidden.
 */
export interface AutoDraftComposerApi {
  /**
   * Resolve true when the composer may receive the draft: immediately when it
   * is empty, otherwise after the host confirms replacing what they typed.
   */
  confirmReplace: () => Promise<boolean>;
  /** Put the draft text in the reply box (and autosave it). */
  load: (text: string) => void;
}

export const AutoDraftComposerContext = createContext<AutoDraftComposerApi | null>(null);

export function useAutoDraftComposer(): AutoDraftComposerApi | null {
  return useContext(AutoDraftComposerContext);
}
